<div class="container py-3">
  <h2>S3 Data Purge</h2>

  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
        <div class="card-title mb-0 me-2">Purge S3 bucket data before:</div>
        <input
          class="form-control"
          type="date"
          [(ngModel)]="purgeBeforeDate"
          [max]="maxAllowedDate"
          style="max-width: 220px;"
        />
        <button class="btn btn-danger ms-2" (click)="onPurgeClick()" [disabled]="loading || running || !isDateValid">
          Purge
        </button>
      </div>

      <div class="text-muted small" *ngIf="!isDateValid">
        To keep the most recent 7 days of data, please select a date on or before <strong>{{ maxAllowedDate }}</strong> (UTC).
      </div>

      <div class="mt-3" *ngIf="taskId">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div class="text-muted">
            <strong>Task:</strong> {{ taskId }}
          </div>
          <div>
            <span class="badge"
                  [ngClass]="{
                    'bg-warning text-dark': status?.state === 'RUNNING',
                    'bg-success': status?.state === 'SUCCEEDED',
                    'bg-danger': status?.state === 'FAILED'
                  }">
              {{ status?.state || (running ? 'RUNNING' : '—') }}
            </span>
          </div>
        </div>

        <div class="text-muted mt-2" *ngIf="status?.message">
          {{ status?.message }}
        </div>

        <div class="table-responsive mt-3" *ngIf="bucketRows.length">
          <table class="table table-sm table-striped align-middle">
            <thead>
              <tr>
                <th>S3 Bucket</th>
                <th style="width: 140px;">Scanned</th>
                <th style="width: 140px;">Deleted</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of bucketRows">
                <td class="font-monospace">{{ row.bucket }}</td>
                <td>{{ row.scanned }}</td>
                <td>{{ row.deleted }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


